
import { 
    IonCardHeader, IonCardTitle
  } from '@ionic/react';

function SingInHeader(){ 

    return (
        <>
            <IonCardHeader>
                <img alt='logo' src='img/logo.png' className='logo-img'></img>
                <IonCardTitle>
                    <h1>Welcome Back!</h1>
                </IonCardTitle>
                <p>Login to your account using mobile number/email:</p>
            </IonCardHeader>
        </>
    )
}

export default SingInHeader;